var map = {
	"./icon-doc.png": 517,
	"./icon-docx.png": 518,
	"./icon-pdf.png": 521,
	"./icon-ppt.png": 428,
	"./icon-pptx.png": 429,
	"./icon-txt.png": 430,
	"./icon-xls.png": 519,
	"./icon-xlsx.png": 520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3557;